import { render, staticRenderFns } from "./previewDetail.vue?vue&type=template&id=0d94ade2&scoped=true&"
import script from "./previewDetail.vue?vue&type=script&lang=js&"
export * from "./previewDetail.vue?vue&type=script&lang=js&"
import style0 from "./previewDetail.vue?vue&type=style&index=0&id=0d94ade2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d94ade2",
  null
  
)

export default component.exports